import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  MessageBox,
  Link,
  MESSAGE_BOX_VARIANT_WARNING,
  MESSAGE_BOX_VARIANT_DANGER
} from 'mailup-web-components'

const ErrorFeedback = ({
  error,
  severity,
  onClickReload,
  className,
  realodPage
}) => {
  const intl = useIntl()
  return error ? (
    <MessageBox className={className} variant={severity}>
      <span>{error}</span>{' '}
      {typeof onClickReload === 'function' && (
        <Link onClick={onClickReload}>
          {intl.formatMessage({ id: realodPage })}
        </Link>
      )}
    </MessageBox>
  ) : null
}

ErrorFeedback.defaultProps = {
  realodPage: 'Load.Common.RealoadPage'
}
ErrorFeedback.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  severity: PropTypes.oneOf([
    MESSAGE_BOX_VARIANT_WARNING,
    MESSAGE_BOX_VARIANT_DANGER
  ]).isRequired,
  onClickReload: PropTypes.func,
  className: PropTypes.string,
  realodPage: PropTypes.string
}

export default ErrorFeedback
